/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FxIdDomainEntitiesPlutusPaymentStatus } from './FxIdDomainEntitiesPlutusPaymentStatus';
import {
    FxIdDomainEntitiesPlutusPaymentStatusFromJSON,
    FxIdDomainEntitiesPlutusPaymentStatusFromJSONTyped,
    FxIdDomainEntitiesPlutusPaymentStatusToJSON,
    FxIdDomainEntitiesPlutusPaymentStatusToJSONTyped,
} from './FxIdDomainEntitiesPlutusPaymentStatus';

/**
 * 
 * @export
 * @interface FxIdApplicationStorePlutusGetPlutusPaymentStatusQueryResponse
 */
export interface FxIdApplicationStorePlutusGetPlutusPaymentStatusQueryResponse {
    /**
     * 
     * @type {FxIdDomainEntitiesPlutusPaymentStatus}
     * @memberof FxIdApplicationStorePlutusGetPlutusPaymentStatusQueryResponse
     */
    Status: FxIdDomainEntitiesPlutusPaymentStatus;
}



/**
 * Check if a given object implements the FxIdApplicationStorePlutusGetPlutusPaymentStatusQueryResponse interface.
 */
export function instanceOfFxIdApplicationStorePlutusGetPlutusPaymentStatusQueryResponse(value: object): value is FxIdApplicationStorePlutusGetPlutusPaymentStatusQueryResponse {
    if (!('Status' in value) || value['Status'] === undefined) return false;
    return true;
}

export function FxIdApplicationStorePlutusGetPlutusPaymentStatusQueryResponseFromJSON(json: any): FxIdApplicationStorePlutusGetPlutusPaymentStatusQueryResponse {
    return FxIdApplicationStorePlutusGetPlutusPaymentStatusQueryResponseFromJSONTyped(json, false);
}

export function FxIdApplicationStorePlutusGetPlutusPaymentStatusQueryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationStorePlutusGetPlutusPaymentStatusQueryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'Status': FxIdDomainEntitiesPlutusPaymentStatusFromJSON(json['Status']),
    };
}

export function FxIdApplicationStorePlutusGetPlutusPaymentStatusQueryResponseToJSON(json: any): FxIdApplicationStorePlutusGetPlutusPaymentStatusQueryResponse {
    return FxIdApplicationStorePlutusGetPlutusPaymentStatusQueryResponseToJSONTyped(json, false);
}

export function FxIdApplicationStorePlutusGetPlutusPaymentStatusQueryResponseToJSONTyped(value?: FxIdApplicationStorePlutusGetPlutusPaymentStatusQueryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Status': FxIdDomainEntitiesPlutusPaymentStatusToJSON(value['Status']),
    };
}

